const ACTIVE_USER = "/user/confirm_access";

export const activeUser = { ACTIVE_USER };
